/*
@author: Nikhil

jvFormTemplate
============
Allows you to build a custom Message template form or a list

Usage:
============
    html : <div jv-form-template="formTemplateConfig" ng-model="formTemplate"></div>
    javascript: Declare a FormTemplateConfig object on the controller scope

    $scope.formTemplateConfig = {
        {Used to set the to list in a send message form}
        to: {
            type: 'readOnly',{to set the type as a readonly field or a editable select2 widget}
            //data: users,{data is used to populate the to list with users, This can be an object declared on the scope or you can specify a get url to fetch the data }
            get: {
                params: ['sRV9VfwA','sSV9VfwB'],{params can be sent as an object or a comma seperated list of values within an array}
                url: '/admin/action/user/search?ids='{Get url to fetch the data for the users}
            },
            responseKey: 'employees'{The ajax function will check for this key in the json response}
        },
        //Used to set the to list in a send message form//
        templates: {
            type: 'dropdown',{Its almost always a dropdown}
            //data: templates,{data is used to populate the template information, This can be an object declared on the scope or you can specify a get url to fetch the data }
            get: {
                url: '/jhire/action/application/pSc9VfwS/noteTemplates'{Get url to fetch the data for the templates}
            },
            responseKey: 'templates'{The ajax function will check for this key in the json response}
        },
        {List is used to show a list of jobs/users etc }
        list: {
            config: {
                type: 'singleSelect',{singleSelect will render each list item with radio. Multiselect will render each list item with a checkbox}
                keyName: 'selectedReqEId',
                resetFilterOn: 'modals.move.show'{resetFilterOn. This variable will be used to reset filters when set to false. The directive will watch this variable and resetFilters when this variable gets set to false. Most common use case is when you hide the modal}
            },
            get: {
                url:'/jhire/action/requisitions?',{Get url to fetch the data for the list}
                params:{
                    page:'0',
                    q:'',
                    maxResults:'10',
                    mine:false
                }{params can be sent as an object or a comma seperated list of values within an array}
            },
            post:{
                callBack: $scope.moveCandidate,{This method will be called when you click on the post button as a callback and all the data will be sent to this method. You can then choose to send the data that is needed to the backend}
                {This button object is required to trigger the post call. Make sure to add a div with class of postActions <div class="postActions"></div> in your html . This button will be appended to this div  }
                button: {
                    label: i18n['MOVE'],
                    type: 'button',
                    classNames:['blue-btn','float-right'],
                    id:'move-btn'
                }
            },
            responseKey: 'jobs',{The ajax function will check for this key in the json response}
            {List can also have one of more filters that are select2 widgets }
            filters: [{
                    label: 'Status',{label that gets rendered next to the filter}
                    data: statusFilter,{data is used to populate the template information, This can be an object declared on the scope or you can specify a get url to fetch the data }
                    keyName: 'reqsStatusFilter'{keyName is used to set a scope variable that holds the ngModel value for this element }
                },
                {
                    label: 'Category',{label that gets rendered next to the filter}
                    get:{
                        url: '/jhire/action/requisitions/filters'{Get url to fetch the data for the list}
                    },
                    keyName: 'reqsCategoryFilter',{keyName is used to set a scope variable that holds the ngModel value for this element }
                    responseKey: 'filters.Categories'
                }
            ],
            search : {
                    label: i18n['SEARCH'],{label for search}
                    get:{
                        url: '/jhire/action/requisitions?', {url to search and filter the results by}
                        params:{
                            workflowId: $scope.workflowEId||0 {params to send to backend with search}
                        }
                    }
            }
        }
    };



*/
angular.module('jv.Common.Directives.Formtemplate', ['jv.Common.Directives.MessageTemplate', 'jv.Common.TemplateLoader','jv.Common.AjaxSelect','ngSanitize'])
    .directive('jvFormTemplate', function factory($http, $q, $log, $timeout, $compile, $window) {

        var directiveDefinitionObject = {
            require: 'ngModel',
            replace: true,
            controller: function($scope) {
                $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
                
                //Setting up i18n to the scope
                $scope.i18n = i18n;
                var  checkCountLimit = 0;

                //Setting up msgDataItem object
                $scope.msgDataItem = {
                    to: [],
                    template: '',
                    subject: '',
                    body: '',
                    scheduledSMS:'',
                    scheduledSMSDate:'',
                    scheduledSMSTime:'',
                    checkScheduledSMS:false
                };

                //setting up modal list object
                $scope.modalList = {
                    query: '',
                    filters: [],
                    page: 0,
                    allItems: [],
                    msgDataItem: {},
                    allReqs:[]
                };
                //setting disabled flags
                $scope.modalList.disabledFlags = $window.disableFlags;

                //watch for selectedReqEId . This is the radio button that is clicked
                $scope.$watch('modalList.selectedReqEId', function(newVal, oldVal) {
                    if (newVal) {
                        $scope.modalList.selectedReqEId = newVal;
                    }
                for (var reqEId in $scope.modalList.selectedReqEId) {
                   if ($scope.modalList.selectedReqEId[reqEId]) {
                       for (var i = 0; i < $scope.modalList.allItems.length; i++) {
                           if (reqEId === $scope.modalList.allItems[i].EId) {
                               $scope.modalList.allReqs[reqEId] = $scope.modalList.allItems[i];
                               break;
                           }
                       }
                   } else {
                       delete $scope.modalList.allReqs[reqEId];
                       delete $scope.modalList.selectedReqEId[reqEId];
                       if (angular.isDefined($scope.modalList.get.filterReqKey)) {
                           delete $scope.modalList.get.filterReqKey[reqEId];
                       }
                   }
                    }
                    if($scope.modalList.get && angular.isDefined($scope.modalList.get.filterReqKey) && Object.keys($scope.modalList.get.filterReqKey).length > 0){
                           checkCountLimit = Object.keys($scope.modalList.get.filterReqKey).length;
                           $scope.modalList.allReqs = $scope.modalList.get.filterReqKey;
                       } else {
                           checkCountLimit = Object.keys($scope.modalList.allReqs).length;
                       }
                           CheckBoxDisable(checkCountLimit);
                }, true);
                $scope.onMessageFieldChange=function() {
                    $scope.msgDataItem.body=[$scope.msgDataItem.body,$scope.msgDataItem.mergeField].join(' ');
                    $scope.msgDataItem.mergeField='';
                }

//                get value from key from the item.
//                The key is an array of string to help traverse inside the item
                $scope.evalData = function(item, key){
                    var val='';
                    if(angular.isDefined(item) && angular.isDefined(key)) {
                        var evalItem = angular.copy(item);
                        if(angular.isArray(key)){
                            for(index in key){
                                val = evalItem[key[index]];
                                evalItem = angular.copy(val);
                            }
                        }
                    }
                    return val;
                };
                var CheckBoxDisable = function(checkCountLimit){
                   if(checkCountLimit >= $scope.modalList.maxSelections){
                       $scope.toggleListItems('disable');
                     }
                   else {
                       $scope.toggleListItems('enable');
                    }
                 };

                $scope.renderColumnData = function(item, dataKey) {
                    if (angular.isObject(dataKey)) {
                        //Need to fix this to return dynamic results for deep objects
                        //var itemVal = $scope.findObjectValue(item,dataKey);
                        if (item && item[dataKey[0]]) {
                            return item[dataKey[0]][dataKey[1]];
                        }
                    } else {
                        return item[dataKey];
                    }
                };

                //set subject and body when user changes template
                $scope.$watch('msgDataItem.template',function(template,oldVal){
                    if(template){
                        $scope.msgDataItem.subject = template.subject;
                        $scope.msgDataItem.body = template.body;
                        $scope.msgDataItem.template = template;
                    }
                });

                $scope.$watch('msgDataItem.scheduledSMSDate', function(scheduledSMSDate) {
                    if (scheduledSMSDate) {
                        $scope.msgDataItem.scheduledSMSDate = scheduledSMSDate;
                    }
                });

                $scope.$watch('msgDataItem.scheduledSMSTime', function(scheduledSMSTime) {
                    if (scheduledSMSTime) {
                        $scope.msgDataItem.scheduledSMSTime = scheduledSMSTime;
                    }
                });

                $scope.$watch('msgDataItem.checkScheduledSMS', function(checkScheduledSMS) {
                    if (!checkScheduledSMS) {
                        $scope.msgDataItem.scheduledSMSDate = '';
                        $scope.msgDataItem.scheduledSMSTime = '';
                    }
                    if (checkScheduledSMS && !$scope.msgDataItem.scheduledSMSDate && !$scope.msgDataItem.scheduledSMSTime) {
                        $scope.formTemplate.promptFiveMinutes = false;
                        $scope.formTemplate.dateTimeEmpty = false;
                    }
                });

                $scope.getSelectedDateUserTimezone = function(scheduledSMSDate) {
                    var userTimeZone = window._jvselfUser.locale.timezone;
                    var selectedDate = new Date(moment.tz(scheduledSMSDate, userTimeZone));
                    return selectedDate;
                };

                //need a more generic function name
                $scope.changeTemplate = function(callBackFn,radioObject){
                    if(typeof (callBackFn) ==='function'){
                        callBackFn.call($scope,radioObject);
                    }
                };

                //Fixme : NV
                $scope.findObjectValue = function(parentObj, keyObject) {
                    $scope.foundData = false;
                    if (keyObject && angular.isObject(keyObject)) {
                        for (var attr in keyObject) {
                            if (!$scope.foundData && parentObj[keyObject[attr]] && angular.isObject(parentObj[keyObject[attr]])) {
                                for (var attrObj in parentObj[keyObject[attr]]) {
                                    $scope.findObjectValue(parentObj[keyObject[attr]], attrObj);
                                }
                            }
                        }
                    } else {
                        $scope.foundData = true;
                        return parentObj[keyObject];
                    }
                };

                //Used to reset search
                $scope.resetSearch = function() {
                    $scope.modalList.query = '';
                    $scope.searchReqs('', 0);
                };

                //Used to paginate
                $scope.paginateModalList = function(direction) {
                    $scope.modalList.disableWhilePaginating = true;
                    $scope.modalList.page = (direction === 'next') ? ($scope.modalList.page + 1) : ($scope.modalList.page - 1);
                    $scope.searchReqs($scope.modalList.query, $scope.modalList.page);
                };

                //Filters results based on a flag
                $scope.filterResults = function(list) {
                    angular.forEach(list, function(filterItem, key) {
                        angular.forEach($scope.modalList.items, function(listItem, key) {
                            if (filterItem.job && filterItem.job[$scope.modalList.get.filterResultsBy.filterKey] === listItem[$scope.modalList.get.filterResultsBy.filterKey]) {
                                listItem.disableCheckbox = true;
                                listItem.showFilterItems = true;
                            }else if (listItem[$scope.modalList.get.filterResultsBy.filterKey] === filterItem[$scope.modalList.get.filterResultsBy.filterKey]){
                                // if the filter list is a list of objects
                                listItem.showFilterItems = true;
                            }else if (listItem[$scope.modalList.get.filterResultsBy.filterKey] === filterItem){
                                // if the filter list is a string array
                                listItem.showFilterItems = true;
                            }
                        });
                    });
                    return $scope.modalList.items;
                };
                //Used to compute size of objects
                $scope.size = function(obj) {
                    var size, key;
                    if (obj === null || typeof obj === 'undefined') {
                        // Do Nothing
                    } else if (angular.isObject(obj)) {
                        size = 0;
                        for (key in obj) {
                            if (obj.hasOwnProperty(key)) {
                                size++;
                            }
                        }
                    } else if (angular.isArray(obj) || angular.isString(obj)) {
                        size = obj.length;
                    } else if (typeof obj === 'number' || angular.isNumber(obj)) {
                        size = obj.toString().length;
                    }
                    return size;
                };

                /*Used to make ajax requests
                @param endPoint url to fetch data from
                */
                $scope.fetchData = function(postObject) {
                    var postData = postObject;
                    var deferred = $q.defer();
                    var count = 0;
                    if (postData.params && angular.isObject(postData.params) && !angular.isArray(postData.params)) {
                        angular.forEach(postData.params, function(key, value) {
                            if (count === ($scope.size(postData.params) - 1)) {
                                postData.url += value + '=' + key;
                            } else {
                                postData.url += value + '=' + key + '&';
                            }
                            count++;
                        });
                    }

                    if (postData.params && angular.isObject(postData.params) && angular.isArray(postData.params)) {
                        postData.url = postData.url + postData.params.join(',');
                    }
                    $http.get(postData.url).then(function(responseData) {
                        var response = responseData.data;
                        var code = responseData.status;

                        if (code === 200 && response) {
                            deferred.resolve(response);
                        }
                    }, function(e){
                        $log.error(e);
                    });
                    return deferred.promise;
                };

                //Used to track if the filters are done loading. ChangeFilter gets fired for each filter that gets rendered.
                $scope.filtersLoaded = false;
                //Function to track filter change
                var changeTimer;
                $scope.changeFilter = function() {
                    if (changeTimer) {
                        $timeout.cancel(changeTimer);
                    }
                    $scope.modalList.page = 0;
                    $scope.modalLoaded = true;
                    changeTimer = $timeout(function() {
                        $scope.searchReqs($scope.modalList.query, 0);
                    }, 300);
                };
                $scope.searchReqs = function(query, page) {
                    $scope.flags.loading = true;
                    //$scope.modalList.selectedReqEId = '';
                    var data = {
                        page: page || 0,
                        q: query || '',
                        maxResults: 10
                    };
                    var searchObject = {};
                    //Lopping through each filter and appending values to the data object that gets posted to the BE
                    angular.forEach($scope.filtersMap, function(filterObj, key) {
                        var filter;
                        if (filterObj.filter) {
                            filter = JSON.parse(filterObj.filter);
                        }
                        if (filter && filter.reset) {
                            filter = '';
                        }
                        //filter = angular.fromJson(filterObj);
                        if (filter && filter.key) {
                            data.jobStateValue = filter.key || '1';
                        }
                        if (filter && filter.mine) {
                            data.mine = filter.mine || false;
                        }
                        if (filter && filter.EId) {
                            data.categoryIds = filter.EId;
                        }
                        if (data && data.jobStateValue === '-1') {
                            delete data.jobStateValue;
                        }
                    });
                    if ($scope.modalList.search && $scope.modalList.search.get && $scope.modalList.search.get.params) {
                        angular.forEach($scope.modalList.search.get.params, function(value, key) {
                            data[key] = value;
                        });
                    }
                    //Seting search object
                    searchObject.url = $scope.modalList.search.get.url;
                    searchObject.params = data;

                    $scope.fetchData(searchObject).then(function(response) {
                        $scope.arrItem = [];
                        if (response && response[$scope.modalList.responseKey]) {
                            $scope.flags.loading = false;
                            $scope.modalList.items = response[$scope.modalList.responseKey];
                            if(angular.isDefined($scope.modalList.get.filterReqKey)){
                            for (key in  $scope.modalList.get.filterReqKey){
                                $scope.arrItem.push(key);
                                }
                             }
                            /**
                             * remove this line so it doesnt keep on adding to memory
                             */
                            angular.forEach(response[$scope.modalList.responseKey], function(value, key) {
                                $scope.modalList.allItems.push(value);
                            });

                            if ($scope.modalList.filterResultsBy) {
                                $scope.modalList.items = $scope.filterResults($scope.modalList.filterResultsBy.list);
                            }
                            $scope.modalList.disableWhilePaginating = false;
                            if (page === 0 || !page) {
                                $scope.modalList.disablePrev = true;
                            } else {
                                $scope.modalList.disablePrev = false;
                            }

                            if($scope.modalList.responseCountKey){
                                $scope.modalList.jobCount = response[$scope.modalList.responseCountKey];
                                response.jobCount = response[$scope.modalList.responseCountKey];
                            }else{
                                $scope.modalList.jobCount = response.jobCount;
                            }

                            if (((page + 1) * 10 >= response.jobCount) || (!response.jobCount)) {
                                $scope.modalList.disableNext = true;
                            } else {
                                $scope.modalList.disableNext = false;
                            }
                            //we need to disable the checkboxes if user has already selected max allowed reqs and tries to search or paginate
                            if(angular.isDefined($scope.modalList.get.filterReqKey)){
                            checkCountLimit = Object.keys($scope.modalList.get.filterReqKey).length;
                            }
                            if(checkCountLimit == 0){
                              $scope.modalList.allReqs =[];
                            }
                            if (checkCountLimit >= $scope.modalList.maxSelections) {
                                //this is to disable the checkboxes when the user has exceded the max section count and paginates using next.
                                //We have a timeout so that we render the new checkboxes fetched throught paginate call or search call  and then disable them.
                                $timeout(function() {
                                    $scope.toggleListItems('disable');
                                }, 200);
                            }
                        }
                    });
                };
                //used to enable/disable checkboxes if maxSelections is set
                $scope.toggleListItems = function(action) {
                    var checkboxes = $('.modalTableView tr td .list-checkbox');
                    if (action === 'disable') {
                        angular.forEach(checkboxes, function(value, key) {
                            if (!$(value).prop('checked')) {
                                $(value).prop('disabled', true);
                            }
                        });
                    } else {
                        angular.forEach(checkboxes, function(value, key) {
                            if (!$(value).prop('checked')) {
                                $(value).prop('disabled', false);
                            }
                        });
                    }
                };
                //used to set default template
                $scope.setDefaultTemplate = function(templateData) {
                    if (templateData) {
                        angular.forEach(templateData, function(template, key) {
                            if (template && template.isDefault) {
                                $timeout(function() {
                                     $scope.msgDataItem.template = template;
                                }, 150);
                                $scope.msgDataItem.subject = template.subject;
                                $scope.msgDataItem.body = template.body;
                            }
                        });
                    }
                };

                $scope.setPrimaryHM = function(primaryHMEId) {
                    if (primaryHMEId) {
                        var primaryHM;
                        angular.forEach($scope.modalList.toList, function(hm, key) {
                            if (hm.EId === primaryHMEId) {
                                primaryHM = {
                                    EId: hm.EId,
                                    fullName: hm.fullName
                                };
                                $scope.primaryHMObj = primaryHM;
                            }
                        });
                        $scope.msgDataItem.to = primaryHM;
                    }
                };
            },
            link: function(scope, iElm, iAttrs, ngModel) {
                var options = scope.$eval(iAttrs.jvFormTemplate);
                var _optionsCopy = angular.copy(options);

                scope.formTemplate.submitted = false;
                var toResultObject, templateResultObject, listResultObject, filterObj, buttonHtml;

                var setupColumns = function() {
                    if (options.list.config && options.list.config.columns) {
                        scope.modalList.columns = {};
                        scope.modalList.columns = options.list.config.columns;
                        angular.forEach(scope.modalList.columns, function(columnObj, key) {
                            angular.forEach(columnObj.key, function(keyVal, index) {
                                if (angular.isObject(keyVal)) {
                                    keyVal = keyVal[0] + '.' + keyVal[1];
                                }
                                if (keyVal.split('.').length > 1) {
                                    var keys = keyVal.split('.');
                                    var newKeyVal = {};
                                    angular.forEach(keys, function(attrValue, attrKey) {
                                        newKeyVal[attrKey] = attrValue;
                                    });
                                    columnObj.key[index] = newKeyVal;
                                }
                            });
                            if (columnObj.show !== true) {
                                if (scope.modalList.columns[columnObj.show]) {
                                    columnObj.show = true;
                                }
                            }
                        });
                        if (options.list.config.defaultTo) {
                            scope.modalList[scope.modalList.keyName] = options.list.config.defaultTo;
                        }
                    }
                };

                scope.fetchTemplates = function(getUrl) {
                    scope.fetchData(getUrl).then(function(result) {
                        if (result) {
                            //load select2
                            scope.modalList.loadSelect2 = true;
                            templateResultObject = formatResultObject(options.templates.responseKey);
                            scope.templateData = eval('{' + templateResultObject + '}');
                            //@i18N: Transform template in Parent-Child to render in groups
                            if(options.templates && options.templates.get && options.templates.get.transform){
                                scope.templateData = options.templates.get.transform(scope.templateData);
                            }
                            //Set msgDataItem
                            scope.setDefaultTemplate(scope.templateData);
                        }
                    });
                };


                scope.fetchListData = function() {
                    setupColumns();
                    if (options.list.filters) {
                        // setting filters will trigger `changeFilter`
                        // so skip fetching list data and only set up filters
                        scope.filtersMap = [];
                        angular.forEach(options.list.filters, function(filter, key) {
                            filterObj = {
                                label: filter.label,
                                keyName: filter.keyName,
                                ghostText: filter.ghostText,
                                allowClear: filter.allowClear,
                                width: filter.width
                            };

                            if (filter.defaultTo) {
                                filterObj.defaultTo = filter.defaultTo;
                                filterObj.filter = filter.defaultTo;
                            }

                            if (filter.data) {
                                scope.modalList[filter.keyName] = filter.data;
                                filterObj.data = filter.data;
                            }
                            else if (angular.isDefined(filter.get)) {
                                scope.fetchData(filter.get).then(function(result) {
                                    //Set category filters
                                    if (result) {
                                        resultObject = formatResultObject(filter.responseKey);
                                        scope.modalList[filter.keyName] = eval('{' + resultObject + '}');
                                        filterObj.data = eval('{' + resultObject + '}');
                                    }
                                });
                            }
                            scope.filtersMap.push(filterObj);
                        });
                    }
                    else {
                        scope.fetchData(options.list.get).then(function(result) {
                            //Set job list
                            if (result) {

                                if(scope.modalList.responseCountKey){
                                    scope.modalList.jobCount = result[scope.modalList.responseCountKey];
                                    result.jobCount = result[scope.modalList.responseCountKey];
                                }

                                if (((scope.modalList.page + 1) * 10 >= result.jobCount) || (!result.jobCount)) {
                                    scope.modalList.disableNext = true;
                                } else {
                                    scope.modalList.disableNext = false;
                                }

                                listResultObject = formatResultObject(options.list.get.responseKey);
                                scope.modalList.items = eval('{' + listResultObject + '}');
                                if (options.list.config && options.list.config.columns) {
                                    scope.modalList.columns.showCompany = result.showCompany;
                                }
                                if (options.list.get && options.list.get.filterResultsBy && options.list.get.filterResultsBy.list) {
                                    scope.modalList.filterResultsBy = options.list.get.filterResultsBy;
                                    scope.modalList.items = scope.filterResults(options.list.get.filterResultsBy.list);

                                    if(options.list.config && options.list.config.keyName && options.list.get.filterResultsBy.filterKey){
                                        scope.modalList[options.list.config.keyName] = {};
                                        for(index in options.list.get.filterResultsBy.list){
                                            if(typeof index === 'object'){
                                                scope.modalList[options.list.config.keyName][options.list.get.filterResultsBy.list[index][options.list.get.filterResultsBy.filterKey]] = true;
                                            }else{
                                                scope.modalList[options.list.config.keyName][options.list.get.filterResultsBy.list[index]] = true;
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }
                };

                var setTooltipObject = function(tooltipObject) {
                    scope.modalList.tooltip = tooltipObject;
                };

                var setModalLabel = function(label) {
                    scope.modalList.label = label;
                };
                //Used to populate the user info
                var setUserInfo = function(userList) {
                    scope.toList = [];
                    angular.forEach(userList, function(value, key) {
                        if (value.fullName) {
                            scope.toList.push(value.fullName);
                        } else {
                            scope.toList.push(value.firstName + ' ' + value.lastName);
                        }
                        scope.msgDataItem.to.push(value.EId);
                    });
                };

                //used to format a result object
                //Format will 0 with the responseKey
                //Eg If responseKey = jobs result.{0} becomes result.jobs and doing an eval on this will give you the object

                var formatResultObject = function(responseKey) {
                    var obj = 'result.{0}';
                    obj = obj.format(responseKey);
                    return obj;
                };
                renderGrid(options);
                scope.$watch(iAttrs.jvFormTemplate, function(newValue, oldValue){
                    if(angular.isDefined(newValue)){
                        options = scope.$eval(iAttrs.jvFormTemplate);
                        renderGrid(options);
                    }
                });

                function renderGrid(options){
                    if(!options){
                        return;
                    }

                    if (options.to && options.templates) {
                        scope.modalList.to = {};
                        scope.modalList.subject = {};
                        scope.modalList.message = {};
                        scope.modalList.templates = {};
                        scope.modalList.scheduledSMS = {};
                        //setting up labels
                        scope.modalList.to.label = options.to.label;
                        scope.modalList.subject = options.subject;
                        scope.modalList.subject.subjectLengthErrorMsg1 = 'Too many characters';
                        scope.modalList.subject.subjectLengthErrorMsg2 = 'Max allowed - 150';
                        scope.modalList.message = options.message;
                        scope.modalList.templates = options.templates;
                        scope.modalList.scheduledSMS = options.scheduledSMS;

                        scope.modalList.msgDataItem = scope.msgDataItem;
                    }

                    //Setting to list
                    if (options.to && options.to.data) {
                        //setting up labels for all fields
                        scope.modalList.to = options.to;
                        if (options.to.type == 'readOnly' && options.to.data.type != 'string') {
                            setUserInfo(options.to.data);
                        } else {
                            //scope.toList = options.to.data.text;
                        }
                        if (options.to.type == 'dropDown') {
                            scope.modalList.toList = options.to.data;
                            if (scope.primaryHM) {
                                scope.setPrimaryHM(scope.primaryHM);
                            } else {
                                scope.msgDataItem.to = scope.modalList.toList[0];
                            }
                        }
                    } else {
                        if (options.to && options.to.get) {
                            scope.modalList.to = options.to;
                            scope.fetchData(options.to.get).then(function(result) {
                                toResultObject = formatResultObject(options.to.responseKey);
                                var userList = eval('{' + toResultObject + '}');
                                if (options.to.type == 'readOnly') {
                                    //Set msgDataItem
                                    setUserInfo(userList);
                                } else {
                                    scope.modalList.toList = userList;
                                    //loading primary hiring manager by default
                                    //Need to find a better way to do this as currently API returns this data in a different key primaryHMEId
                                    scope.setPrimaryHM(result.submitToHM.model.primaryHMEId);
                                }
                            });
                        }
                    }
                    //setting from radio buttons
                    if (options.from) {
                    $timeout(function(){
                        scope.modalList.from = options.from;
                        angular.forEach(scope.modalList.from, function(value, key) {
                            if (value && value.data.optionsValues) {
                                angular.forEach(value.data.optionsValues, function(optionVal, k) {
                                    if (optionVal && optionVal.checked && scope.modalList.from[k]) {
                                        scope.modalList[scope.modalList.from[k].data.key] = optionVal.label;
                                    }
                                });

                            }
                        });
                        }, 200);
                    }

                    //setting templateType personal templates / company templates radio buttons
                    if (options.templateType) {
                        scope.modalList.templateType = options.templateType;
                    }
                    if (options.customHtml) {
                        scope.modalList.customHtml = options.customHtml;
                    }

                    //Setting Template data
                    if (options.templates && options.templates.data) {
                        scope.templateData = angular.copy(options.templates.data);
                        $timeout(function(){
                            scope.modalList.loadSelect2 = true;
                            scope.setDefaultTemplate(scope.templateData);
                        }, 200);
                    } else {
                        if (options.templates && options.templates.get) {
                            //fetch templates
                            scope.fetchTemplates(options.templates.get);
                            //submit to HM does default templates differently than send message.
                            if (scope.templateData) {
                                scope.setDefaultTemplate(scope.templateData);
                            }
                        }
                    }



                    //post callback integration
                    if ((options.list && options.list.post && options.list.post.button) || (options.templates && options.templates.post && options.templates.post.button)) {
                        var btnObj = {};
                        options.list ? btnObj = options.list.post.button : btnObj = options.templates.post.button;
                        options.list ? scope.modalList.callBack = options.list.post.callBack : scope.modalList.callBack = options.templates.post.callBack;
                        buttonHtml = '<button id="' + btnObj.id + '"class="btn-blue marginRight5 margin-left-small ' + btnObj.classNames.join(' ') + '">' + btnObj.label + '</button>';
                        $('#'+btnObj.id).remove();
                        $(iElm).next('.postActions').append(buttonHtml);
                    //}
                    $('#' + btnObj.id).on('click', function() {
                        scope.formTemplate.subjectLengthError = false;
                        scope.$apply(function() {
                            scope.formTemplate.$dirty = true;
                            scope.formTemplate.submitted = true;
                            //check for empty subject
                            scope.formTemplate.subjectEmpty = false;
                            if(scope.modalList.subject && !scope.modalList.subject.isSms && !scope.msgDataItem.subject){
                                 scope.formTemplate.subjectEmpty  = true;
                                 scope.formTemplate.$invalid = true;
                            }

                            //check for empty message
                            scope.formTemplate.messageEmpty = false;
                            if(!scope.msgDataItem.body){
                                 scope.formTemplate.messageEmpty  = true;
                                 scope.formTemplate.$invalid = true;
                            }

                            //validate scheduled date&time for send sms message
                            scope.formTemplate.promptFiveMinutes = false;
                            scope.formTemplate.dateTimeEmpty = false;
                            if (scope.modalList.scheduledSMS && scope.msgDataItem.checkScheduledSMS) {
                                if ((!scope.msgDataItem.scheduledSMSDate && scope.msgDataItem.scheduledSMSTime) || (scope.msgDataItem.scheduledSMSDate && !scope.msgDataItem.scheduledSMSTime) || (!scope.msgDataItem.scheduledSMSDate && !scope.msgDataItem.scheduledSMSTime)) {
                                    scope.formTemplate.dateTimeEmpty = true;
                                    scope.formTemplate.$invalid = true;
                                } else if (scope.msgDataItem.scheduledSMSDate && scope.msgDataItem.scheduledSMSTime) {
                                    var formattedDateTime = scope.getSelectedDateUserTimezone(scope.msgDataItem.scheduledSMSDate);
                                    formattedDateTime.setHours((scope.msgDataItem.scheduledSMSTime).h);
                                    formattedDateTime.setMinutes((scope.msgDataItem.scheduledSMSTime).m);
                                    var checkDate = formattedDateTime.getDifference(new Date());
                                    if (checkDate > 300000) {
                                        scope.msgDataItem.scheduledSMS = formattedDateTime.toISOString();
                                        scope.formTemplate.$invalid = false;
                                    } else {
                                        scope.formTemplate.promptFiveMinutes = true;
                                        scope.formTemplate.$invalid = true;
                                    }
                                }
                            }

                            //validations for list
                            if (scope.modalList.type == 'singleSelect' || scope.modalList.type == 'multiSelect') {
                                if ($.isEmptyObject(scope.modalList[scope.modalList.keyName])) {
                                    scope.formTemplate.$invalid = true;
                                } else {
                                    scope.formTemplate.$invalid = false;
                                }
                            }
                             if(scope.modalList.subject && !scope.modalList.subject.isSms){
                                if (scope.msgDataItem.subject && scope.msgDataItem.subject.length > 150){
                                    scope.formTemplate.$invalid = true;
                                    scope.formTemplate.subject.$invalid = true;
                                    scope.formTemplate.subjectLengthError = true;
                                }

                                if (!scope.formTemplate.subjectEmpty  && !scope.formTemplate.messageEmpty && (scope.msgDataItem.subject.length <= 150)) {
                                    scope.formTemplate.$invalid = false;
                                    scope.formTemplate.subject.$invalid = false;
                                    scope.formTemplate.subjectLengthError = false;
                                }
                            }
                            if(Object.keys(scope.modalList.allReqs).length > 0){
                               scope.formTemplate.$invalid = false;

                            }

                            if (!scope.formTemplate.$invalid) {
                                scope.modalList.msgDataItem = scope.msgDataItem;
                                scope.modalList.callBack(scope.modalList);
                            }
                        });
                    });
                    }

                    scope.modalList.fileUploader = false;
                    //Add FileUploader
                    if (options.fileUploader) {
                        scope.modalList.fileUploader = options.fileUploader;
                    }

                    if (options.resetModalOn) {
                        scope.modalList.resetModalOn = options.resetModalOn;
                    }
                    //Loading list data
                    if (options.list) {
                        scope.modalList.show = true;
                        scope.modalList.type = options.list.config.type;
                        //validation requirements
                        scope.modalList.errorText = options.list.config.errorText;
                        scope.modalList.emptySearchText = options.list.config.emptySearchText;
                        scope.modalList.required = options.list.config.required;
                        //respose key
                        scope.modalList.responseKey = options.list.get.responseKey;
                        scope.modalList.keyName = options.list.config.keyName;
                        scope[scope.modalList.keyName] = '';
                        scope.modalList[options.list.config.keyName] = {};
                        scope.filtersMap = [];
                        scope.modalList.get = options.list.get;

                        if(options.list.get.responseCountKey){
                            scope.modalList.responseCountKey = options.list.get.responseCountKey;
                        }

                        if (options.list.config.label) {
                            setModalLabel(options.list.config.label);
                        }
                        scope.modalList.maxSelections = options.list.config.maxSelections;
                        if (scope.listUrl) {
                            options.list.get.url = scope.listUrl;
                            options.list.search.get.url = scope.listUrl;
                        }

                        scope.fetchListData();

                        if (options.list.config && options.list.config.tooltip) {
                            setTooltipObject(options.list.config.tooltip);
                        }

                        if (options.list.search) {
                            scope.modalList.query = '';
                            scope.modalList.search = {};
                            scope.modalList.search.get = options.list.search.get;
                            scope.modalList.search.labelText = options.list.search.label;
                            scope.modalList.search.placeholder = options.list.search.placeholder;
                            scope.modalList.search.title = options.list.search.title;
                        }

                        if (options.list.config && options.list.config.validationText) {
                            scope.modalList.validationText = options.list.config.validationText;
                        }
                    } //end options.list
                }

                //To make sure the filters are not sticky

                scope.$watch(scope.modalList.resetModalOn, function(newVal, oldVal) {
                    //if new values is true and old value is false
                    if (newVal && !oldVal) {
                        //Reset the options
                        options = scope.$eval(iAttrs.jvFormTemplate);
                        //renderGrid(options);
                        //This is used to track when the modal was loaded
                        scope.modalLoaded = false;
                        //ready to load select2
                        scope.modalList.loadSelect2 = true;
                        scope.formTemplate.$dirty = false;
                        scope.formTemplate.submitted = false;
                        scope.formTemplate.subjectLengthError = false;
                        //clearing attachments
                        scope.msgDataItem = {};
                        $('.qq-upload-list').html('');
                        $('.uploader-error').text('');
                        angular.forEach(scope.filtersMap, function(filterObj, key) {
                            filterObj.filter = '';
                        });
                        if (options.templateType) {
                            scope.modalList.templateType = options.templateType;
                        }
                        if (options.from && options.from[0].data.key) {
                            scope.modalList[options.from[0].data.key] = $window._jvselfUser.fullName;
                        }
                        //Need a better way to do this
                        if (scope.primaryHMObj) {
                             scope.msgDataItem.to = scope.primaryHMObj;
                        } else {
                            if (scope.modalList.toList) {
                                scope.msgDataItem.to = scope.modalList.toList[0];
                            }
                        }
                        if (options.list) {
                            //remove search text
                            scope.modalList.query = '';
                            if (scope.listUrl) {
                                options.list.get.url = scope.listUrl;
                                options.list.search.get.url = scope.listUrl;
                            }
                            //setTooltipObject
                            setTooltipObject(options.list.config.tooltip);
                            //setModalLabel
                            setModalLabel(options.list.config.label);
                            //fetchListData
                            scope.fetchListData();
                            //resetModalList.page
                            scope.modalList.page = 0;
                            //Resetting all checkbox and radio button values on click of cancel or when the modal is closed
                            scope.modalList[options.list.config.keyName] = {};
                        } else {
                            if (options.templates.get) {
                                scope.fetchTemplates(options.templates.get);
                            } else {
                                scope.templateData = angular.copy(options.templates.data);
                                scope.setDefaultTemplate(scope.templateData);

                            }
                        }

                    }else{
                        scope.modalList.loadSelect2 = false;
                        //Reset the template type dropdown . Fix for https://jobvite.atlassian.net/browse/HIRE-9375 Need to reset to company templates.
                        if(scope.modalList.templates && scope.modalList.templateType){
                            scope.modalList.templates.type = 'dropDown';
                            var key = scope.modalList.templateType[0].data.key;
                            scope.modalList[key] = '';
                        }
                    }
                }, true);

                //setting form dirty flag to false on load
                $timeout(function() {
                    scope.formTemplate.$dirty = false;
                }, 150);

            },

            templateUrl: '/__assets__/scripts/common/directives/FormTemplate/FormTemplate.html'
        };

        return directiveDefinitionObject;
    });
